import { Box } from '@mui/material';

import { OTooltip } from '@src/shared';
import ShareMeetingModal from '../ShareMeetingModal';
import CreateMeetingMenu from './partials/CreateMeetingMenu';

import { copyMessageToClipboard } from '@src/helpers';

import useCreateMeetingAction from './useCreateMeetingAction';

import styles from './createRoomAction.module.scss';

const CreateMeetingAction = ({ joinRoom }: { joinRoom: () => void }) => {
  const {
    anchorEl,
    isModalOpen,
    meetingLink,
    isMenuOpen,
    isTitleEmpty,
    handleClose,
    handleOpenModal,
    setAnchorEl,
    setIsModalOpen,
    navigateToWebinar,
    handleScheduleInCalendar,
  } = useCreateMeetingAction();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (!isTitleEmpty) {
      setAnchorEl(event.currentTarget);
    }
  };

  return (
    <Box>
      <OTooltip title={isTitleEmpty ? 'Enter a meeting title to create a meeting' : ''}>
        <button
          id="create-meeting-button"
          className={`pulse ${styles.createRoomFormButton} ${isTitleEmpty ? styles.disabledButton : styles.buttonPrimary}`}
          onClick={handleClick}
        >
          Create Meeting
        </button>
      </OTooltip>

      <CreateMeetingMenu
        handleClose={handleClose}
        handleOpenModal={handleOpenModal}
        joinRoom={joinRoom}
        isMenuOpen={isMenuOpen}
        isTitleEmpty={isTitleEmpty}
        anchorEl={anchorEl}
        navigateToWebinar={navigateToWebinar}
        handleScheduleInCalendar={handleScheduleInCalendar}
      />

      <ShareMeetingModal
        isModalOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Share the room info"
        link={meetingLink || ''}
        description="Send this to the people you'd like to meet with. Make sure to save it for later use as well."
        onCopy={(link) => copyMessageToClipboard(link, 'Link copied successfully')}
        primaryButton={{
          label: 'Via QR Code',
          onClick: () => {
            if (meetingLink) {
              navigator.share?.({ url: meetingLink });
            }
          },
        }}
        secondaryButton={{
          label: 'Mail Invitation',
          disabled: true,
          tooltip: 'Coming soon',
          onClick: () => {},
        }}
      />
    </Box>
  );
};

export default CreateMeetingAction;
